var map = {
	"./hey_jude.json": [
		883,
		883
	],
	"./led_zeppelin_whole_lotta_love.json": [
		949,
		949
	],
	"./nirvana_smells_like_teen_spirit.json": [
		605,
		605
	],
	"./pink_floyd_another_brick_in_the_wall.json": [
		146,
		146
	],
	"./queen_we_will_rock_you.json": [
		322,
		322
	],
	"./veech_shelo.json": [
		393,
		393
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 703;
module.exports = webpackAsyncContext;